export const INITIATE_PROJECT_PAYMENT = `project/payment/initiate`; //#!DONE
export const VERIFY_PROJECT_PAYMENT = { 
  //#!DONE  
  VERIFY: ({ trxref, reference }) => `project/payment/verify-transaction?trxref=${trxref}&reference=${reference}`,
};
export const ALL_MY_PAYMENTS = `project/payment/my-transactions`; //#!DONE
export const MY_SUCCESSFUL_PAYMENTS = `project/payment/my-successful-transactions`; //#!DONE